import { useContext } from 'react';
import { QuestionaireContext } from '../providers/questionaire';

export default function useQuestionaireContext() {
  const context = useContext(QuestionaireContext);
  if (context === undefined) {
    throw new Error('useQuestionaireContext must be used within an QuestionnaireContextProvider');
  }
  return context;
}
